import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/inspection/item',
    name: 'inspectionItemPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
